import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { connect } from 'react-redux';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Header from './Header';
import HeaderMobile from './Mobile/';
import HeaderDashboard from './Dashboard';
import * as ROUTES from '../../routes/';
import { DashBoardAdmin } from '../../layouts/DashBoardAdmin';
import { right } from 'styled-system';

function HeaderContainer({
  isExpandedSideMenu,
  handleOpenSideMenu,
  handleOpenMenu,
  authClient,
  statusUser,
  openDrawer,
  handleToggleDrawer,
}) {
  const mdScreen = useMediaQuery('(max-width:1359px)');
  const tablet = useMediaQuery('(max-width:768px)');

  const role =
    authClient &&
    authClient.role ?
    authClient.role : ''
  const membershipType =
    authClient &&
    authClient.membership &&
    authClient.membership.type ?
    authClient.membership.type : ''

  const clientSections = [
    {
      name: 'Encontrar abogado',
      link: 'scroll',
      to: 'searchLawyer',
      duration: 500,
    },
    {
      name: 'Abogados Plus',
      link: 'scroll',
      to: 'abogados-top',
      duration: 1000,
    },
    {
      name: 'Despachos Plus',
      link: 'scroll',
      to: 'abogados-top',
      duration: 1500,
    },
    {
      name: '¿Cómo funciona?',
      link: 'scroll',
      to: 'funciona',
      duration: 1500,
    },
     {
      name: 'Articulos',
      link: 'router',
      to: '/articulos',
    },
    (role === 'cliente' || !role || membershipType === 'Premium')
      ? {
        name: 'Comunidad',
        link: 'router',
        to: '/comunidad',
      }
    : null,
  ];

  const lawyerSections = [
    {
      name: 'Quiénes somos',
      link: 'scroll',
      to: 'about',
      duration: 500,
    },
    {
      name: 'Beneficios',
      link: 'scroll',
      to: 'benefits',
      duration: 1000,
    },
    {
      name: '¿Cómo funciona?',
      link: 'scroll',
      to: 'how',
      duration: 1500,
    },
    {
      name: 'Comunidad',
      link: 'scroll',
      to: 'lawyers_com',
      duration: 1500,
    },
    {
      name: 'Articulos',
      link: 'router',
      to: '/articulos',
    },
    (role === 'cliente' || !role || membershipType === 'Premium')
      ? {
        name: 'Comunidad',
        link: 'router',
        to: '/comunidad',
      }
    : null,
  ];

  const userSections = [
    {
      name: 'Artículos',
      link: 'router',
      to: '/articulos',
    },
    (role === 'cliente' || !role || membershipType === 'Premium')
      ? {
        name: 'Comunidad',
        link: 'router',
        to: '/comunidad',
      }
    : null,
  ];

  const blog = useRouteMatch(ROUTES.ARTICLES);
  const moreInfo = useRouteMatch(ROUTES.ADDITIONAL_INFO);
  const landing300 = useRouteMatch(ROUTES.LANDING_PAGE_300);
  const landingLawyers = useRouteMatch(ROUTES.LANDING_PAGE);
  const lawyerSearch = useRouteMatch(ROUTES.SEARCH_LAWYER);
  const lawyerView = useRouteMatch(ROUTES.LAWYER_VIEW);
  const lawfirmView = useRouteMatch(ROUTES.LAWYERFIRM_VIEW);
  const lawyerPreview = useRouteMatch(ROUTES.LAWYER_PREVIEW_VIEW);

  const clientLawyers = useRouteMatch(ROUTES.LAWYERS_CONTACTED);
  const clientNotif = useRouteMatch(ROUTES.NOTIFICATIONS_CLIENT);
  const clientAcc = useRouteMatch(ROUTES.CLIENT_ACCOUNT);
  const thankyou = useRouteMatch(ROUTES.THANKYOU_PAGE);
  const dahsboard = useRouteMatch(ROUTES.HOME);
  const dahsboardAdmin = useRouteMatch(ROUTES.DASHBOARD_ADMIN);
  const community = useRouteMatch(ROUTES.COMUNITY);

  return dahsboard || dahsboardAdmin ? (
      <HeaderDashboard
        profile={statusUser && statusUser === 2? authClient:null}
        isExpandedSideMenu={isExpandedSideMenu}
        handleOpenSideMenu={handleOpenSideMenu}
        handleOpenMenu={handleOpenMenu}
        openDrawer={openDrawer}
        handleToggleDrawer={handleToggleDrawer}
      />
  ) : landing300 || moreInfo || thankyou ? (
    !tablet ? (
      <Header />
    ) : (
      <HeaderMobile logoPosition="logoLeft" />
    )
  ) : lawyerSearch || lawyerView || lawfirmView || lawyerPreview|| clientLawyers || clientNotif || clientAcc  ? (
    !tablet ? (
      <Header userdata={statusUser && statusUser === 2? authClient:null} wildcard />
    ) : (
      <HeaderMobile userdata={statusUser && statusUser === 2? authClient:null} logoPosition="logoLeft" hbutton />
    )
  ) : blog || community ? (
    !mdScreen ? (
      <Header userdata={statusUser && statusUser === 2? authClient:null} sections={userSections} wildcard justifyLeft />
    ) : (
      <HeaderMobile
        userdata={statusUser && statusUser === 2? authClient:null}
        sections={userSections}
        logoPosition="logoLeft"
        hbutton
      />
    )
  ) : landingLawyers ? (
    !mdScreen ? (
      <Header userdata={statusUser && statusUser === 2? authClient:null} sections={lawyerSections} wildcard />
    ) : (
      <HeaderMobile
        userdata={statusUser && statusUser === 2? authClient:null}
        sections={lawyerSections}
        logoPosition="logoRight"
        hbutton
      />
    )
  ) : !mdScreen ? (
    <Header userdata={statusUser && statusUser === 2? authClient:null} sections={clientSections} wildcard='client' />
  ) : (
    <HeaderMobile
      userdata={statusUser && statusUser === 2? authClient:null}
      sections={clientSections}
      logoPosition="logoRight"
      hbutton
    />
  );
}

const mapStateToProps = state => ({
  authClient: state.authClient,
  statusUser: state.userState.statusUser,
});


export default connect(mapStateToProps)(HeaderContainer);
